export const ru = {
  app: {
    name: 'Судоку',
    title: 'Судоку',
  },
  seo: {
    title:
      'Судоку онлайн бесплатно — от лёгких до сложных, с подсказками | BN-games',
    description:
      'Играйте в судоку бесплатно в браузере — новые головоломки 9×9 трёх уровней сложности, пометки, отмена хода и подсказки, объясняющие следующий логический шаг.',
    social:
      'Бесплатное судоку 9×9 в браузере — три уровня сложности и подсказки с объяснениями.',
    h1:
      'Судоку онлайн бесплатно',
    intro:
      'Судоку — логическая головоломка на поле 9×9: заполните каждую строку, каждый столбец и каждый квадрат 3×3 цифрами от 1 до 9 так, чтобы ни одна не повторялась. Считать ничего не нужно — только логика.\n\nBN-games создаёт новую головоломку для каждой партии, на выбор три уровня сложности. Есть пометки карандашом, отмена и повтор хода, а подсказка показывает следующий логический шаг и объясняет его — так она учит приёму, а не просто заполняет клетку. Бесплатно, без регистрации, а ещё есть приложение для iOS и Android.',
    rulesTitle:
      'Правила судоку — как играть | BN-games',
    rulesDescription:
      'Как играть в судоку: правила классической головоломки 9×9 простыми словами — и сразу решать новую головоломку онлайн бесплатно, с подсказками.',
    rulesH1:
      'Правила судоку: как играть',
    playCta:
      'Решать судоку',
  },
  common: {
    back: '← Назад',
    cancel: 'Отмена',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Закрыть',
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
    friendPicker: {
      button: 'Пригласить друга',
      modalTitle: 'Пригласить друга',
      loading: 'Загрузка друзей…',
      signInPrompt: 'Войдите, чтобы пригласить друга.',
      empty: 'У вас пока нет друзей.',
      findFriends: 'Найти друзей',
      invite: 'Пригласить',
      inviteAria: 'Пригласить {{name}}',
      invited: 'Приглашён',
      invitedAria: '{{name}} приглашён',
      notAccepting: 'Этот игрок сейчас не принимает приглашения',
      retryIn: 'Повторите через {{seconds}} с',
    },
    addOpponent: {
      buttonMany: 'Добавить друзей…',
      modalTitle: 'Добавить друзей',
      add: 'Добавить {{name}} в друзья',
      added: 'Добавлен',
      addedAria: '{{name}} добавлен в друзья',
    },
  },
  online: {
    resumeModal: {
      seatTakenTitle: 'Место занято',
      seatTakenBody: 'Это место принадлежит другому аккаунту. Войдите под тем аккаунтом или начните новую игру.',
      roomGoneTitle: 'Стол закрыт',
      roomGoneBody: 'Эта партия завершена — стол закрыт.',
      roomFullTitle: 'Комната заполнена',
      roomFullBody: 'Все места за этим столом заняты, и ни одно из них не ваше.',
      anonymousTitle: 'Не можем подтвердить, что это место ваше',
      anonymousBody: 'В этом браузере нет записи об этой игре. Войдите в аккаунт перед следующей онлайн-игрой, и ваше место будет доступно с любого устройства.',
      unreachableTitle: 'Не удалось связаться с сервером',
      unreachableBody: 'Сервер не отвечает. Проверьте соединение и попробуйте снова.',
      signIn: 'Войти',
      retry: 'Повторить',
    },
  },
  mainMenu: {
    quickStart: 'Быстрый старт',
    newGame: 'Новая головоломка',
    rules: 'Правила',
    settings: 'Настройки',
    history: 'История игр',
    about: 'О игре',
  },
  play: {
    title: 'Новая головоломка',
    startButton: 'Начать',
    resume: 'Продолжить',
    difficulty: {
      easy: 'Лёгкая',
      medium: 'Средняя',
      hard: 'Сложная',
    },
  },
  settings: {
    title: 'Настройки',
    difficulty: 'Сложность по умолчанию',
    highlightErrors: 'Подсвечивать ошибки',
    theme: 'Тема',
    language: 'Язык',
    back: '← Назад',
    tabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
    },
    difficulties: {
      easy: 'Лёгкая',
      medium: 'Средняя',
      hard: 'Сложная',
    },
    themes: {
      mahogany: 'Махагон',
      persian: 'Персидская',
      deco: 'Деко',
      monte: 'Монте',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
  },
  rules: {
    title: 'Правила',
    body: 'Судоку — логическая головоломка на сетке 9×9, разделённой на девять блоков 3×3. В некоторых клетках уже стоят цифры от 1 до 9, остальные пусты.\n\nЦель — заполнить все пустые клетки так, чтобы в каждой строке, каждом столбце и каждом блоке 3×3 цифры от 1 до 9 встречались ровно по одному разу. У головоломки всегда есть единственное решение, которое находится чистой логикой — гадать не нужно.',
  },
  about: {
    title: 'О игре',
    body: 'Браузерное судоку на TypeScript и HTML5 Canvas. В первой версии — три уровня сложности, карандашные пометки, отмена и повтор хода, подсказки с названиями техник, подсветка ошибок, таймер с паузой, ссылки для отправки головоломки друзьям и сохранение истории с повторами.',
  },
  history: {
    title: 'История игр',
    empty: 'Сохранённых игр пока нет — реши головоломку, чтобы заполнить список.',
    replayButton: 'Повтор',
    column: {
      completedAt: 'Завершена',
      difficulty: 'Сложность',
      time: 'Время',
      hints: 'Подсказки',
      errors: 'Ошибки',
    },
  },
  historyList: {
    justNow: 'только что',
    minutesAgo: '{{count}} мин назад',
    hoursAgo: '{{count}} ч назад',
    daysAgo: '{{count}} дн назад',
    hintsCount: 'подсказок: {{count}}',
    errorsCount: 'ошибок: {{count}}',
    deleteAria: 'Удалить запись',
    deleteConfirm: 'Удалить запись?',
    clearAll: 'Очистить всё',
    clearAllConfirm: 'Очистить всю историю?',
    clearAllBody: 'Все завершённые головоломки будут удалены. Действие нельзя отменить.',
    forfeitedTag: 'Сдача',
  },
  game: {
    timer: {
      label: 'Время',
    },
    stats: {
      game: 'Игра',
      errors: 'Ошибки',
    },
    hint: {
      button: 'Подсказка',
    },
    pencil: {
      button: 'Заметки',
    },
    erase: {
      button: 'Стереть',
    },
    undo: {
      button: 'Отменить',
    },
    redo: {
      button: 'Повтор',
    },
    win: {
      banner: 'Решено!',
    },
    a11y: {
      canvasLabel: 'Поле судоку. Стрелками перемещайте выбранную клетку, 1–9 — ввод цифры, Backspace — стереть, P — режим карандаша, Z — отменить, Y — повторить, Escape — пауза.',
      cellAnnouncement: 'Строка {{row}}, столбец {{col}}, {{value}}.',
      cellEmpty: 'пусто',
      cellGiven: 'подсказка {{digit}}',
      cellEntered: 'введено {{digit}}',
      hintAnnouncement: '{{technique}}: смотри строку {{row}}, столбец {{col}}.',
      errorAnnouncement: 'Неверная цифра.',
    },
    end: {
      title: 'Головоломка решена!',
      subtitle: 'Сложность: {{difficulty}}',
      timeLabel: 'Время',
      hintsLabel: 'Подсказки',
      errorsLabel: 'Ошибки',
      playAgain: 'Сыграть ещё раз',
      backToMenu: 'В меню',
      a11yAnnounce: 'Судоку решено за {{time}}. Использовано подсказок: {{hints}}, допущено ошибок: {{errors}}.',
      forfeitedTitle: 'Решение показано',
      forfeitedSubtitle: 'Вы сдались на этой головоломке.',
      viewSolution: 'Показать поле',
    },
  },
  pause: {
    title: 'Пауза',
    resume: 'Продолжить',
    settings: 'Настройки',
    share: 'Поделиться',
    restart: 'Начать заново',
    quit: 'Выйти в меню',
    solve: 'Показать решение',
    solveConfirm: {
      title: 'Показать решение?',
      message: 'Головоломка завершится и попадёт в историю как сдача.',
      confirm: 'Показать',
      cancel: 'Отмена',
    },
  },
  share: {
    modal: {
      title: 'Поделиться головоломкой',
      copyButton: 'Копировать ссылку',
      copied: 'Скопировано!',
      systemShareButton: 'Поделиться…',
    },
    banner: {
      text: 'Прислал {{from}} — решено за {{time}}.',
    },
  },
  hint: {
    technique: {
      'naked-single': 'Голый одиночка',
      'hidden-single': 'Скрытый одиночка',
      'naked-pair': 'Голая пара',
      'pointing-pair': 'Указывающая пара',
      'box-line': 'Блок-линия',
      'x-wing': 'Х-крыло',
    },
  },
  error: {
    shareLink: {
      invalid: 'Ссылка повреждена. Проверь адрес ещё раз.',
      outdated: 'Эта ссылка из старой версии и больше не открывается.',
      generic: 'Не удалось открыть присланную головоломку. Попроси прислать свежую ссылку.',
    },
    unknown: 'Что-то пошло не так. Попробуй ещё раз.',
  },
  replay: {
    controls: {
      first: 'В начало',
      previous: 'Назад',
      play: 'Воспроизвести',
      pause: 'Пауза',
      next: 'Вперёд',
      last: 'В конец',
      speed: 'Скорость',
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Доступно обновление',
      body: 'Готова новая версия Судоку. Обновите страницу, чтобы загрузить её.',
      refresh: 'Обновить',
      later: 'Позже',
    },
  },
};
